import { render } from "./EmployeeIdCard.vue?vue&type=template&id=3b9cde00"
import script from "./EmployeeIdCard.vue?vue&type=script&lang=js"
export * from "./EmployeeIdCard.vue?vue&type=script&lang=js"

import "./EmployeeIdCard.vue?vue&type=style&index=0&id=3b9cde00&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__